import { useEffect, useState } from "react";
import { useBookingDialog } from "@/contexts/BookingDialogContext";
 
const NAV = [
  { label: "How it works", href: "#how" },
  { label: "Contracts", href: "#contracts" },
  { label: "For brands", href: "#brands" },
  { label: "Creators", href: "#creators" },
  { label: "Coverage", href: "#coverage" },
  { label: "FAQ", href: "#faq" },
];
 
export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { openDialog } = useBookingDialog();
 
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
 
  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FFFFFF]/80 backdrop-blur-xl border-b border-[#B1B7AB]/40"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center"
        >
          <img
            src="/Lychee%20Logo_Single%20text%20logo.svg"
            alt="Lychee"
            className="h-11 w-auto"
          />
        </a>
        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-[#0D3A35]/80 hover:text-[#0D3A35] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>
        <button
          type="button"
          onClick={() => openDialog()}
          data-testid="header-cta"
          className="inline-flex items-center gap-1.5 h-10 px-5 rounded-full bg-[#0D3A35] text-white text-sm font-medium hover:bg-[#276152] transition-colors"
        >
          Book consultation
          <span aria-hidden>→</span>
        </button>
      </div>
    </header>
  );
}
